import { Avatar, AvatarFallback, cn, Icon, Skeleton } from '@kognitos/lattice';
import type {
  WorkspaceColorType,
  WorkspaceIconType,
} from '@/modules/onboarding/constants';

interface IWorkspaceIdentifierProps {
  color: WorkspaceColorType;
  icon: WorkspaceIconType;
  isLoading?: boolean;
  className?: string;
}

/**
 * @param color - The color of the workspace identifier.
 * @param icon - The icon of the workspace identifier.
 *
 * Default color is 'color-6' and default icon is 'Grip'.
 *
 * @returns The workspace identifier.
 */
const WorkspaceIdentifier = ({
  color,
  icon = 'Grip',
  isLoading = false,
  className,
}: IWorkspaceIdentifierProps) => {
  if (isLoading) {
    return (
      <Skeleton
        className={cn('h-5 w-5 rounded-lg bg-alternate-1', className)}
      />
    );
  }
  return (
    <Avatar className={cn('h-5 w-5 rounded-xs bg-alternate-1', className)}>
      <AvatarFallback className="rounded-xs" style={{ backgroundColor: color }}>
        <Icon
          type={icon}
          size="xs"
          className="text-sidebar-primary-foreground"
        />
      </AvatarFallback>
    </Avatar>
  );
};

export default WorkspaceIdentifier;
